import { Link } from 'react-router-dom'

export default function PageNotFound() {
  return (
    <div className="min-h-screen bg-[#f0f4f3] flex items-center justify-center">
      <div className="clay-card p-12 text-center space-y-4">
        <div className="text-6xl">🌿</div>
        <h1 className="text-3xl font-bold text-gray-800">Page Not Found</h1>
        <p className="text-gray-500">This page doesn't exist.</p>
        <Link to="/" className="inline-block mt-4 clay-button px-6 py-3 rounded-2xl font-semibold">
          Go Home
        </Link>
      </div>
    </div>
  )
}